import Vue from 'vue';
import Tools from '@/libs/utils';
/**
 * @description 补零
 * @param val
 */
const zeroFill = val => {
  return val < 10 ? `0${val}` : val;
};
const Filters = {
  ...Tools,
  /**
   * @description 格式化时长
   * @param result
   */
  formatDuration (result) {
    if (!result || typeof result !== 'number') return '00:00';
    result = Math.abs(result);
    const h = Math.floor(result / 3600);
    const m = Math.floor((result / 60 % 60));
    const s = Math.floor((result % 60));
    if (h > 0) {
      return `${zeroFill(h)}:${zeroFill(m)}:${zeroFill(s)}`;
    } else {
      return `${zeroFill(m)}:${zeroFill(s)}`;
    }
  },
  /**
   * @description 保留两位小数
   * @param val
   * @return {number}
   */
  decimal (val) {
    const num = Number(val);
    if (isNaN(num)) return;
    return num.toFixed(2);
  },
  /**
   * @description 姓名脱敏
   * @param name
   */
  nameHide (name) {
    if (typeof name === 'string') {
      const str = name.substring(1);
      return name.replace(str, '**');
    }
  },
  /**
   * @description 手机号脱敏
   * @param num
   * @returns {*}
   */
  encryptPhone (num) {
    if (!num) return;
    const pat = /(\d{3})\d*(\d{4})/;
    return num.replace(pat, '$1 **** $2');
  },
  /**
   * @description 身份证脱敏
   * @param num
   * @returns {*}
   */
  encryptIdNo (num) {
    if (!num) return;
    const pat = /(\d{4})\d*(\d{4})/;
    return num.replace(pat, '$1 *********** $2');
  },
  /**
   * @description 姓名脱敏
   * @param str
   * @returns {string}
   */
  encryptName (str) {
    if (str !== null && str !== undefined) return;
    if (str.length <= 3) {
      return '*' + str.substring(1, str.length);
    } else if (str.length > 3 && str.length <= 6) {
      return '**' + str.substring(2, str.length);
    } else if (str.length > 6) {
      return str.substring(0, 2) + '****' + str.substring(6, str.length);
    }
  },
  /**
   * @description 获取图片预览地址
   * @param file
   * @return {string}
   */
  getPicPreviewUrl (file) {
    let url = null;
    // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
    if (window.createObjectURL !== undefined) { // basic
      url = window.createObjectURL(file);
    } else if (window.URL !== undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    return url;
  }
};

// 注册过滤器
Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key]);
});

export default Filters;
